import React from "react";
import styled from "styled-components";
import { ThemedSpan } from "../../../utilities";

export const Container = styled.div`
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 20;
`;

const GraphLiveMessage = (
    { text = "The following data is live directly from the Microsoft Graph API and covers all subscriptions they recognise. You can choose to link or create matching database records where WealthPro cannot find a matching record." } : Readonly<{ text?: string | JSX.Element }>
) => {
    return (
        <Container>
            <ThemedSpan variant="muted" className="p-3">{text}</ThemedSpan>
        </Container>
    );
};

export default GraphLiveMessage;